import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Button from "../../components/Button";
import { Input } from "../../components/Input";
import PaddingContainer from "../../components/PaddingContainer";
import Phone from "../../components/PhoneInput";
import ProfilePicture from "../../components/ProfilePicture";
import { MailIcon, user, UserIcon } from "../../constant";
import { userSchema } from "../../schema";
import useApi from "../../useApi";
import classes from "./Profile.module.css";
const initialValues = {
  name: "",
  cellNumber: "",
  password: "",
  email: "abc@gmail.com",
  image: user,
  password: "",
};
const Profile = () => {
  const { updateProfile } = useApi();
  const [loading, setLoading] = useState(false);
  const { auth } = useSelector((state) => state);
  console.log("state == >", auth);
  const updateProfileApi = async (params) => {
    setLoading(true);
    const response = await updateProfile(params);

    if (response?.data?.headers?.error === 200) {
      setValues({
        email: values?.email,
        image: values?.image,
        name: values?.name,
        cellNumber: auth?.user?.userCellNumber,
      });
      toast.success("Profile updated successfully");
      setFieldValue("password", "");
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: response?.data?.headers?.message,
        life: 3000,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    console.log("auth == >", auth);
    setValues({
      email: auth?.email,
      image: auth?.image,
      name: auth?.name,
      cellNumber: auth?.cellNumber,
    });
  }, [auth]);
  const formik = useFormik({
    initialValues,
    validationSchema: userSchema,
    validateOnChange: false, // Disable validation on change
    validateOnBlur: false, // Disable validation on blur
    onSubmit: (values, { resetForm }) => {
      console.log("values", values);
      const params = {
        countryCode: values?.cellNumber.slice(0, 3),
        cellNumber: values?.cellNumber?.slice(3),
        name: values?.firstName + values?.lastName,
        image: values?.image,
        password: values?.password,
      };
      updateProfileApi(params);
    },
  });

  const {
    touched,
    errors,
    setValues,
    resetForm,
    values,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
  } = formik;
  const handleChangeWithTouch = (field) => (value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };
  console.log("errors", errors);

  console.log("IMMAGE", values?.image);
  console.log("errors (())", errors);
  return (
    <>
      <PaddingContainer style={{ height: "calc(100% - 104px)" }}>
        <form onSubmit={handleSubmit} className={classes.wrapper}>
          <ProfilePicture
            value={values?.image}
            onChange={handleChangeWithTouch("image")}
          />

          <Row className={classes.gridWrapper}>
            <Col sm={12}>
              <Input
                isOptional={true}
                customStyle={{ paddingRight: "16px" }}
                type="text"
                label={"Name"}
                placeholder="Enter Name"
                value={values?.name}
                onChange={handleChangeWithTouch("name")}
                errorText={touched.name && errors.name} // Show error if touched
                rightIcon={
                  <span className={classes.userIcon}>
                    <UserIcon />
                  </span>
                }
              />
            </Col>
            {/* <Col sm={6}>
                <Input
                  isOptional={true}
                  customStyle={{ paddingRight: "16px" }}
                  value={values?.lastName}
                  onChange={handleChangeWithTouch("lastName")}
                  type="text"
                  label={"Last Name"}
                  placeholder="Enter Last Name"
                  setter={handleChangeWithTouch("lastName")}
                  errorText={touched.lastName && errors.lastName} // Show error if touched
                  rightIcon={
                    <span className={classes.userIcon}>
                      <UserIcon />
                    </span>
                  }
                />
              </Col> */}

            {/* <Col sm={12}>
                <Input
                  isOptional={true}
                  value={values.cellNumber}
                  customStyle={{ paddingRight: "16px" }}
                  onChange={handleChangeWithTouch("cellNumber")}
                  type="text"
                  label={"Contact Number"}
                  placeholder="Enter Contact Number"
                  errorText={touched.cellNumber && errors.cellNumber} // Show error if touched
                  rightIcon={
                    <span className={classes.userIcon}>
                      <ContactIcon />
                    </span>
                  }
                />
              </Col> */}

            <Col sm={12}>
              <Phone
                isOptional={true}
                value={values?.cellNumber}
                onChange={handleChangeWithTouch("cellNumber")}
                errorText={touched.cellNumber && errors.cellNumber} // Show error if touched
              />
            </Col>
            <Col sm={12}>
              <Input
                disabled={true}
                isOptional={true}
                value={values.email}
                customStyle={{ paddingRight: "16px" }}
                type="text"
                label={"Email Address"}
                onChange={handleChangeWithTouch("email")}
                placeholder="Enter Email Address"
                errorText={touched.email && errors.email} // Show error if touched
                rightIcon={
                  <span className={classes.userIcon}>
                    <MailIcon />
                  </span>
                }
              />
            </Col>
            <Col sm={12}>
              <Input
                isOptional={true}
                value={values.password}
                customStyle={{ paddingRight: "16px" }}
                type="password"
                label={"Password"}
                onChange={handleChangeWithTouch("password")}
                placeholder="Enter New Password"
                errorText={touched.password && errors.password} // Show error if touched
              />
              <p className={classes.passwordText}>
                Enter a new password to change your password
              </p>
            </Col>
          </Row>
          <div className={classes.bottomAction}>
            <div className={classes.ctas}>
              <Button
                variant="secondary"
                label="Discard Changes"
                onClick={() => resetForm()} // Reset the form fields
              />
              <Button
                variant="primary"
                type="submit"
                label="Save Changes"
                disabled={loading}
              />
            </div>
          </div>
        </form>
      </PaddingContainer>
    </>
  );
};

export default Profile;
